import React, { useState, useEffect } from "react";
import { Col, Row, Form, Spinner, Button } from '@themesberg/react-bootstrap';
import { useCookies } from 'react-cookie';
import { getAvailableGames } from '../../../../../../controller/api/employee';

export const AddNewEmployeeForm = (props) => {
  const [cookies] = useCookies(['lottmekong']);
  const [games, setGames] = useState([]);
  const [loadingGames, setLoadingGames] = useState(false);
  const [selectedGameIds, setSelectedGameIds] = useState([]);

  useEffect(() => {
    loadGames();
  }, []);

  const loadGames = async () => {
    setLoadingGames(true);
    try {
      const result = await getAvailableGames(cookies.lottmekong);
      if (result && result.status === 'success') {
        setGames(result.data || []);
      }
    } catch (err) {
      console.error('Error loading games:', err);
    }
    setLoadingGames(false);
  };

  const onNameChange = (evt) => {
    props.setName(evt.target.value)
  }

  const onPasswordChange = (evt) => {
    props.setPassword(evt.target.value)
  }

  const onPhoneChange = (evt) => {
    props.setPhone(evt.target.value)
  }

  const onIdentifyChange = (evt) => {
    props.setIdentify(evt.target.value)
  }

  const handleGameToggle = (gameId) => {
    setSelectedGameIds(prev => {
      const newSelection = prev.includes(gameId)
        ? prev.filter(id => id !== gameId)
        : [...prev, gameId];

      props.setGames(newSelection);
      return newSelection;
    });
  };

  const handleSelectAll = () => {
    const newSelection = selectedGameIds.length === games.length ? [] : games.map(g => g.id);
    setSelectedGameIds(newSelection);
    props.setGames(newSelection);
  };

  return (
    <Form>
      <Row>
        <Col md={6} className="mb-2">
          <Form.Group>
            <Form.Label>Username <span className="text-danger">*</span></Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Nhập username"
              onChange={onNameChange}
            />
          </Form.Group>
        </Col>
        <Col md={6} className="mb-2">
          <Form.Group>
            <Form.Label>Mật khẩu <span className="text-danger">*</span></Form.Label>
            <Form.Control
              required
              type="password"
              placeholder="Nhập mật khẩu (tối thiểu 6 ký tự)"
              onChange={onPasswordChange}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="mb-2">
          <Form.Group>
            <Form.Label>Số điện thoại (không bắt buộc)</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nhập số điện thoại"
              onChange={onPhoneChange}
            />
          </Form.Group>
        </Col>
        <Col md={6} className="mb-2">
          <Form.Group>
            <Form.Label>CMND/CCCD (không bắt buộc)</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nhập số CMND/CCCD"
              onChange={onIdentifyChange}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={12} className="mb-2">
          <Form.Group>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <Form.Label className="mb-0">Games được gán</Form.Label>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={handleSelectAll}
                disabled={loadingGames}
              >
                {selectedGameIds.length === games.length ? 'Bỏ chọn tất cả' : 'Chọn tất cả'}
              </Button>
            </div>

            {loadingGames ? (
              <div className="text-center py-2">
                <Spinner animation="border" size="sm" />
                <span className="ms-2">Đang tải games...</span>
              </div>
            ) : (
              <div className="border rounded p-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {games.map(game => (
                  <Form.Check
                    key={game.id}
                    type="checkbox"
                    id={`new-game-${game.id}`}
                    label={
                      <div>
                        <strong>{game.name}</strong> ({game.gameType})
                        <br />
                        <small className="text-muted">{game.prizeValue}</small>
                      </div>
                    }
                    checked={selectedGameIds.includes(game.id)}
                    onChange={() => handleGameToggle(game.id)}
                    className="mb-2"
                  />
                ))}
                {games.length === 0 && (
                  <div className="text-center text-muted py-2">
                    Không có game nào khả dụng
                  </div>
                )}
              </div>
            )}

            <Form.Text className="text-muted">
              Có thể gán/thay đổi games sau khi tạo nhân viên.
            </Form.Text>

            {selectedGameIds.length > 0 && (
              <div className="mt-2">
                <small className="text-info">
                  Đã chọn {selectedGameIds.length} game(s)
                </small>
              </div>
            )}
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};
